import { message } from "antd";
import { SuccessIcon } from "../../CustomIcons";

export const SuccessMessage = (text: string) => {
  message.success({
    key: "success",
    duration: 2,
    content: (
      <div className="toast_wrapper">
        <div className="toast_text">{text}</div>
      </div>
    ),
    icon: <SuccessIcon />,
  });
};
